import axios, { AxiosError } from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { Environment } from '../../../environment';
import { jwtDecode } from 'jwt-decode';
import { Api } from '../axios-config';

export interface ILanProducao {
  idlanpro: string;
  idproducao: string;
  idfun: string;
  idpivot: string;
  datalan: Date;
  periodo: string;
  qtd: number;
  vlatividade: number;
  vladicional: number;
  meta: number;
  acmeta: number;
  total: number;
}

export interface IListagemConfProducao {
  idconf: string;
  descricao: string;
}

export interface IListagemProducao {
  idproducao: string;
  descricao: string;
}

type TCeiComTotalCount = {
  data: IListagemConfProducao[];
  totalCount: number;
}

type TotalCount = {
  data: IListagemProducao[];
  totalCount: number;
}

type TotalCountConf = {
  data: IListagemConfProducao[];
  totalCount: number;
}

interface ErrorResponse {
  error: {
    default: string;
  };
}

interface JwtPayload {
  faz: string;
  loc: string;
}

const handleError = (error: any): Error => {
  if (error?.response) {
    const msg = error.response.data?.error?.default || 'Erro desconhecido';
    return new Error(msg);
  } else if (error?.request) {
    return new Error('Nenhuma resposta do servidor');
  } else {
    return new Error(error?.message || 'Erro inesperado');
  }
};

const getAll = async (page = 1, filter = ''): Promise<TCeiComTotalCount | Error> => {
  try {
    let idfazenda;
    const accessToken = localStorage.getItem('APP_ACCESS_TOKEN');
    if (accessToken) {
      const decoded = jwtDecode<JwtPayload>(accessToken);
      idfazenda = decoded.faz;
    }
    const urlRelativa = `/lanproducao?page=${page}&limit=${Environment.LIMITE_DE_LINHAS1}&filter=${filter}&idfazenda=${idfazenda}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS1),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return handleError(error);
  }
};

const getById = async (id: string): Promise<ILanProducao | Error> => {
  try {
    const { data } = await Api.get(`/lanproducao/${id}`);
    if (data) return data;
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    return handleError(error);
  }
};

const create = async (dados: ILanProducao): Promise<string | Error> => {
  try {
    let idfazenda: string | undefined;
    const accessToken = localStorage.getItem('APP_ACCESS_TOKEN');
    if (accessToken) {
      const decoded = jwtDecode<JwtPayload>(accessToken);
      idfazenda = decoded.faz;
    }
    if (!idfazenda) {
      return new Error('ID da fazenda não encontrado no token.');
    }
    console.log('create', dados)
    const guuid = uuidv4();
    const body = {
      ...dados,
      idlanpro: guuid,
      idfazenda,
    };

    const { data } = await Api.post('/lanproducao', body);
    if (!data || Object.keys(data).length === 0) {
      return guuid;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    return handleError(error);
  }
};

const updateById = async (id: string, dados: ILanProducao): Promise<void | Error> => {
  try {
    await Api.put(`/lanproducao/${id}`, dados);
  } catch (error) {
    return handleError(error);
  }
};

const deleteById = async (id: string): Promise<void | Error> => {
  try {
    await Api.delete(`/lanproducao/${id}`);
  } catch (error) {
    return handleError(error);
  }
};

const getAlllist = async (id = '', filter = ''): Promise<TotalCount | Error> => {
  try {
    const urlRelativa: string = id === ''
      ? `/lanproducao?limit=${Environment.LIMITE_DE_CADASTRO}&filter=${filter}`
      : `/lanproducaolist/${id}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_CADASTRO),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return handleError(error);
  }
};

const getAlllistConf = async (id = '', filter = ''): Promise<TotalCountConf | Error> => {
  try {
    let idfazenda;
    const accessToken = localStorage.getItem('APP_ACCESS_TOKEN');
    if (accessToken) {
      const decoded = jwtDecode<JwtPayload>(accessToken);
      idfazenda = decoded.faz;
    }
    const urlRelativa: string = id === ''
      ? `/lanproducaolist?limit=${Environment.LIMITE_DE_CADASTRO}&filter=${filter}&idfazenda=${idfazenda}`
      : `/lanproducaolist/${id}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_CADASTRO),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return handleError(error);
  }
};

export const LanProducaoService = {
  getAll,
  create,
  getById,
  updateById,
  deleteById,
  getAlllist,
  getAlllistConf,
};